import store from "@/store/";
import Vue from "vue";
import Router from "vue-router";
import config from "@/config/baseConfig";
import { constantRoutes, asyncRoutes } from "./router.config";

Vue.use(Router);
let routers = config.permission.router
  ? constantRoutes
  : constantRoutes.concat(asyncRoutes);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: routers
});

router.push = function(location, onComplete, onAbort) {
  if (location && location.name) {
    store.dispatch("app/deletePageKeepAlive", location.name);
  }
  this.history.push(location, onComplete, onAbort);
};
router.replace = function(location, onComplete, onAbort) {
  if (location && location.name) {
    store.dispatch("app/deletePageKeepAlive", location.name);
  }
  this.history.replace(location, onComplete, onAbort);
};

export default router;
